import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../../ApiConfig";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import {
  GetMaritalListListActionTypes,
  GET_MARITAL_STATUS_LIST_FAIL,
  GET_MARITAL_STATUS_LIST_LOADING,
  GET_MARITAL_STATUS_LIST_SUCCESS,
} from "./ActionTypes";
import { GetMaritalListListRes } from "./Model";
import { headers } from "../../../component/Utility";

export const getMaritalListList = () => {
  return function (dispatch: Dispatch<GetMaritalListListActionTypes>) {
    dispatch({
      type: GET_MARITAL_STATUS_LIST_LOADING,
    });
    setupInterceptorsTo(axios)
      .get(
        baseUrl.baseUrl + `/patientapp/api/patient/maritial_list_dropdown`,
        { headers: headers }
      )
      .then((res) => {
        dispatch({
          type: GET_MARITAL_STATUS_LIST_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_MARITAL_STATUS_LIST_FAIL,
          payload: {} as GetMaritalListListRes,
          errRes: error.response.data.message,
        });
      });
  };
};
